import { render, staticRenderFns } from "./MasterResultPlus.vue?vue&type=template&id=2b2b752a&scoped=true"
import script from "./MasterResultPlus.vue?vue&type=script&lang=js"
export * from "./MasterResultPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b752a",
  null
  
)

export default component.exports